import { environment } from '@env/environment';

const DNS_LABEL_PATTERN = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i;

export class SubdomainUrlUtils {
  static isValidSubdomain(subdomain: string | undefined): boolean {
    return !!subdomain && DNS_LABEL_PATTERN.test(subdomain);
  }

  static resolveOrgSubdomainUrl(
    subdomain: string | undefined,
    path: string,
    isWhitelabel = false,
    protocol = globalThis.location.protocol
  ): string | null {
    const { enabled, baseDomain } = environment.subdomainOrgFilter ?? {};

    if (
      !enabled ||
      !baseDomain ||
      isWhitelabel ||
      !this.isValidSubdomain(subdomain)
    ) {
      return null;
    }

    return `${protocol}//${subdomain}.${baseDomain}${path}`;
  }
}
